import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { environment } from '@environments/environment';
import { AppComponent } from './app/app.component';
import { CORE_PROVIDERS } from './app/core-providers';
import { CORE_ROUTES } from './app/core-routes';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    ...CORE_PROVIDERS,
    provideZonelessChangeDetection(),
    provideRouter(
      CORE_ROUTES,
      withRouterConfig({ onSameUrlNavigation: 'reload', paramsInheritanceStrategy: 'always' }),
      withComponentInputBinding(),
    ),
    provideAnimations(),
  ],
});
